






















import { PropType } from 'vue';
import { ButtonToggleOption } from './ButtonToggleOption.model';
import IconContainer from '../IconContainer.vue';
import Icon from '../Icon.vue';
export default {
  components: { Icon, IconContainer },
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    options: { type: Array as PropType<ButtonToggleOption[]>, required: true },
    selected: { type: String, default: null },
    withCheckmark: { type: Boolean, default: true },
  },
  emits: ['change'],
  computed: {},
  methods: {
    setSelected(selected: string) {
      this.$emit('change', selected);
    },
  },
};
